import {Component, OnChanges, OnInit, SimpleChanges,} from "@angular/core";
import {
    AppointmentDto,
    AsAppointmentLocationTypeInternal,
    AsAppointmentStatusInternal
} from "../../../model/dto/entity/appointment.dto";
import {ConfirmationService, MenuItem} from "primeng/api";
import {AppointmentTypeService} from "../../../service/api/appointment-type.service";
import {AppointmentTypeDto} from "../../../model/dto/entity/appointment-type.dto";
import {CustomerDto} from "../../../../cr/model/dto/entity/customer.dto";
import {CustomerContactService} from "../../../../cr/service/api/customer-contact.service";
import {CustomerContactDto} from "../../../../cr/model/dto/entity/customer-contact.dto";
import {AppointmentService} from "../../../service/api/appointment.service";
import {EventAppointmentHelper} from "../../../helper/event-appointment.helper";
import {AgentDto} from "../../../../../feature-core/am/model/dto/entity/agent.dto";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {LmLeadDto} from "../../../../lm/model/dto/entity/lm-lead.dto";
import {TicketDto} from "../../../../../feature-core/tm/model/dto/entity/ticket.dto";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {TicketService} from "../../../../../feature-core/tm/service/api/ticket.service";
import {ObjectTypeService} from "../../../../../core/cc/service/api/object-type.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {EntityStatusEnum} from "../../../../../core/shared/entity/enum/entity-status.enum";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {MsCalendarEventDto} from "../../../../../feature-core/am/model/dto/api/ms/ms-calendar.types";
import {MvsCrudObjectHistoryService} from "../../../../../core/shared/crud/service/mvs-crud-object-history.service";

/**
 * Not Sure
 */
@Component({
    selector: "as-appointment-component",
    templateUrl: "./as-appointment-event.component.html",
    styleUrls: ["./as-appointment-event.component.scss"],
    standalone: false,
})
export class AsAppointmentEventComponent extends ObjectBaseComponent
    implements OnInit, OnChanges {

    appointment: AppointmentDto;
    agent: AgentDto;
    customer: CustomerDto;
    lead: LmLeadDto;
    customerContactDto: CustomerContactDto[];
    event: MsCalendarEventDto;
    ticket: TicketDto;

    addressId: number;

    customerContactWidget: WidgetData;
    customerAddressWidget: WidgetData;

    appointmentType: AppointmentTypeDto;

    appointmentWidgetData: WidgetData;

    photoUrl: string;

    isEditing: boolean = false;
    travelTime: string;
    travelDistance: number;
    busy: boolean = false;


    isCancelAppointment: boolean = false;
    isCancelAppointmentAndCreateTicket: boolean = false;
    isRescheduleAppointmentWithCurrentAgent: boolean = false;
    isRescheduleAppointmentWithNewAgent: boolean = false;
    isSubView: boolean = false;

    currentView: 'ticketView' | 'subView' | 'mainView' = 'mainView'

    referenceObjectIdentifier: ObjectIdentifier;
    name: string;


    items: MenuItem[];

    constructor(
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected messageService: MvsMessageService,
        protected observerService: ObserverService,
        protected appointmentTypeService: AppointmentTypeService,
        protected appointmentService: AppointmentService,
        protected customerContact: CustomerContactService,
        protected ticketService: TicketService,
        protected objectHistory: MvsCrudObjectHistoryService,
        protected objectTypeService: ObjectTypeService,
        protected navigationService: MvsObjectNavigationService) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        this.initButtonMenu();
        this.getAppointmentDetails();
        this.travelTime = this.params?.travelTime;
        this.travelDistance = this.params?.travelDistance;

    }

    getAppointmentDetails() {
        // this.refreshWidgets();
        if (this.busy) {
            return;
        }
        this.busy = true;
        this.appointmentService.getAppointmentFull(this.objectIdentifier.objectId).subscribe(res => {

            this.appointment = res.appointment;
            this.customer = res.customer;
            this.lead = res.lead;
            this.agent = res.agent;
            this.event = res.event;

            this.addressId = this.appointment?.addressDtoId;

            if (this.lead) {
                this.name = this.lead.calculatedName;
                this.referenceObjectIdentifier = new ObjectIdentifier('lm.LmLead', this.lead.id);
            }

            if (this.customer) {
                this.name = this.customer.calculatedName;
                this.referenceObjectIdentifier = new ObjectIdentifier('cr.Customer', this.customer.id);
            }


            if (this.event) {

                const startTime = new Date(`${this.event['startAsLocalDateTime']}Z`).toISOString();
                const endTime = new Date(`${this.event['endAsLocalDateTime']}Z`).toISOString();

                this.event['startTimeLocal'] = new Date(startTime);
                this.event['endTimeLocal'] = new Date(endTime);
            }

            if (!this.event && this.appointment) {

                const startTime = new Date(`${this.appointment.startTime}Z`).toISOString();
                const endTime = new Date(`${this.appointment.endTime}Z`).toISOString();

                this.appointment['startTimeLocal'] = new Date(startTime);
                this.appointment['endTimeLocal'] = new Date(endTime);
            }


            this.refreshCustomerContactWidget();
            this.refreshCustomerAddressWidget();

            // this.getCustomerContact();
            this.getTickets();
            this.getAppointmentType();

            this.initialized = true;
            this.busy = false;
        });

    }


    async getTickets() {
        if (this.appointment.originReferenceObjectTypeDtoId && this.appointment.originReferenceObjectId) {

            const objectType = await this.objectTypeService.getViaObjectId(this.appointment.originReferenceObjectTypeDtoId)

            if (objectType.alias == 'tm.TicketAction') {


                const filterCriteria = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.appointment.originReferenceObjectId);

                const objectRequestList = ObjectRequestList.createBasic(false, [filterCriteria], []);

                objectRequestList.objectRequestComplex = ObjectRequestComplex.build(true, false, ObjectRequestComplexNode.createSimpleAttributeNode("ticket"))

                const crudService: MvsCrudService = this.coreService.getCrudService(objectType.alias);

                crudService.list(objectRequestList).subscribe(res => {
                    this.ticket = res.entries[0].ticketDto;
                });
            }

        }
    }

    getAppointmentType() {
        this.appointmentTypeService.get(this.appointment.appointmentTypeDtoId).subscribe(appointmentType => {
            this.appointmentType = <AppointmentTypeDto>appointmentType;
        });
    }



    refreshCustomerContactWidget() {

        this.customerContactWidget = WidgetFactory.createWidgetListEntityBasicQl('as.appointment.cr.customer.contact.widget', 'Customer Contacts', 'cr.CustomerContact', [FilterCriteria.create('e.customerId', FilterCriteria.cOperatorEqual, this.customer?.id)]);
    }

    refreshCustomerAddressWidget() {

        this.customerAddressWidget = WidgetFactory.createWidgetListEntityBasicQl('as.appointment.cr.customer.address.widget', 'Customer Address', 'cr.CustomerAddress', [FilterCriteria.create('e.customerId', FilterCriteria.cOperatorEqual, this.customer?.id)]);
    }
    // TicketId: 1000001244 Show history of appointment
    historyAppointment() {
        this.objectHistory.showHistory('as.Appointment', this.appointment.id, onLoadHistory => {

        });
    }

    showCustomer() {
        const entry = MvsObjectNavigationEntry.createNavigationEntry('cr.Customer', this.customer?.id, null, 'Customer', null, null, MvsObjectNavigationActionEnum.any);
        this.navigationService.openObjectInNewTab(entry);
    }

    getShortLink(url: string): string {
        if (!url) return '';
        return url.length > 35 ? url.slice(0, 32) + '...' : url;
    }

    copyToClipboard(cpoyLink: string) {
        navigator.clipboard.writeText(cpoyLink);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
    }

    hasBuffer(event: string) {
        if (event)
            return EventAppointmentHelper.getDurationInSeconds(event);
        else return 0;
    }

    initButtonMenu() {
        this.items = [
            {
                label: 'Termin absagen',
                command: () => {
                    this.cancelAppointment();
                }
            },
            {
                label: 'Termin absagen und Ticket erstellen',
                command: () => {
                    this.cancelAppointmentAndCreateTicket();
                }
            },
            {separator: true},
            {
                label: 'Termin verschieben (Agent bleibt)',
                command: () => {
                    this.rescheduleAppointmentWithCurrentAgent();
                }
            }, {
                label: 'Termin verschieben (neuer Agent)',
                command: () => {
                    this.rescheduleAppointmentWithNewAgent();
                }
            },
        ];
    }


    cancelAppointment() {
        this.activeSubMenu();
        this.isCancelAppointment = true;
    }

    cancelAppointmentAndCreateTicket() {
        this.activeSubMenu();
        this.isCancelAppointmentAndCreateTicket = true;
    }

    rescheduleAppointmentWithCurrentAgent() {
        this.activeSubMenu();
        this.isRescheduleAppointmentWithCurrentAgent = true;
    }

    rescheduleAppointmentWithNewAgent() {
        this.activeSubMenu();
        this.isRescheduleAppointmentWithNewAgent = true;
    }

    activeSubMenu() {
        this.currentView = 'subView'
        this.isSubView = true;
    }

    clearSubMenu() {

        this.isSubView = false;
        this.currentView = 'mainView';
        this.isCancelAppointment = false;
        this.isCancelAppointmentAndCreateTicket = false;
        this.isRescheduleAppointmentWithCurrentAgent = false;
        this.isRescheduleAppointmentWithNewAgent = false;
    }

    handleAppointmentChange() {
        this.isSubView = false;
        this.currentView = 'mainView';
        this.getAppointmentDetails();
    }

    protected readonly EntityStatusEnum = EntityStatusEnum;
    protected readonly AsAppointmentLocationTypeInternal = AsAppointmentLocationTypeInternal;
    protected readonly AsAppointmentStatusInternal = AsAppointmentStatusInternal;
}

